export default "__VITE_ASSET__DBxfj2Vg__"